import React from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import { productQueries } from '../../../../graphql/queries';
import Product from './Product.js';
import ProductSkeleton from '../../../../Components/Skeletons/ProductSkeleton';
import NotFoundMessage from '../../../../Components/Store/NotFoundMessage.js';

const VoucherWrapper = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, loading } = useQuery(productQueries.GiftVoucherProductById, {
    variables: { id: parseInt(id) }
  });

  if (loading) {
    return <ProductSkeleton />;
  }

  // null (unknown id) or an errored query both mean there's nothing to show — fall back
  // gracefully instead of handing a null product to <Product>, which derefs product.id.
  const product = data && data.giftVoucherProductById;

  if (!product) {
    return (
      <NotFoundMessage
        message='voucher-not-found'
        actionLabel='browse-vouchers'
        onAction={() => navigate('/products/vouchers')}
      />
    );
  }

  return (<Product product={product} />);
};

export default VoucherWrapper;
